module.exports = {"bewizr-agenda":{"empty":{"title":"Geen activiteiten","detail":"Je hebt op dit moment geen activiteiten in je agenda."}}}